export const STATUS_LABELS = {
  pending_approval: 'Pendiente de aprobación',
  approved: 'Aprobado',
  in_transit: 'En tránsito',
  partial_delivery: 'Entrega parcial',
  delivered: 'Entregado',
  cancelled: 'Cancelado',
};

export const STATUS_COLORS = {
  pending_approval: 'bg-amber-100 text-amber-800',
  approved: 'bg-blue-100 text-blue-800',
  in_transit: 'bg-indigo-100 text-indigo-800',
  partial_delivery: 'bg-purple-100 text-purple-800',
  delivered: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export const STATUS_FLOW = ['pending_approval', 'approved', 'in_transit', 'partial_delivery', 'delivered', 'cancelled'];
